import { createFileRoute } from '@tanstack/react-router'
import { AccountTemplatesPanel } from '@/components/accounts/AccountTemplatesPanel'
import { accountQuery, reportTemplatesQuery, reportsOverviewQuery } from '@/lib/queries'

/**
 * The account's Templates page. The content lives in AccountTemplatesPanel, shared with the client
 * workspaces' templates pages — templates are account-owned and clients inherit them, so both
 * places render the same panel; only the URL (and header phrasing) differs.
 */
export const Route = createFileRoute('/app/accounts/$accountId_/templates/')({
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(accountQuery(params.accountId)),
      context.queryClient.ensureQueryData(reportTemplatesQuery(params.accountId)),
      context.queryClient.ensureQueryData(reportsOverviewQuery),
    ]),
  component: AccountTemplatesPage,
})

function AccountTemplatesPage() {
  const { accountId } = Route.useParams()
  return <AccountTemplatesPanel accountId={accountId} />
}
